// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PrimaryLanguage = t.struct({
    allowedPrimaryLanguages: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'PrimaryLanguage',
    strict: true
});

export const getDefaultState = () => new PrimaryLanguage({
    allowedPrimaryLanguages: [],
    key: '',
    value: ''
});

export default PrimaryLanguage;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/primary-language.js